import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MaOverviewStatsResource} from '@services/resource/ma-overview-stats-resource';
import {HttpClient} from '@angular/common/http';
import {ClientConfig} from '@app/client-config';
import {ErrorService} from '@services/error.service';
import {map, timeout} from 'rxjs/operators';
import {ConfigService} from '@services/infra/config.service';
import {HpOverviewStatsResource} from '@services/resource/hp-overview-stats-resource';
import {HpOverviewStats} from '@services/model/hp-overview-stats';

@Injectable({
  providedIn: 'root',
})
export class StatsService {
  constructor(
    private readonly errors: ErrorService,
    private readonly http: HttpClient,
    private readonly conf: ConfigService,
  ) {}

  public getMaOverviewStats(): Observable<MaOverviewStatsResource> {
    const url = `${this.conf.backendUrl}/v1/stats/ma-overview`;
    return this.http.get<MaOverviewStatsResource>(url).pipe(timeout(ClientConfig.timeout), this.errors.withErrorHandler());
  }

  public getHpOverviewStats(): Observable<HpOverviewStats> {
    const url = `${this.conf.backendUrl}/v1/stats/hp-overview`;
    return this.http.get<HpOverviewStatsResource>(url).pipe(
      timeout(ClientConfig.timeout),
      this.errors.withErrorHandler(),
      map((r) => HpOverviewStats.fromResource(r)),
    );
  }
}
